import { useMemo } from 'react';
import { getStackedValuesFromDataSeries } from '../utilities/getStackedValuesFromDataSeries.js';
import { getStackedMinMax } from '../utilities/getStackedMinMax.js';

function useHorizontalStackedValues({
  data,
  isStacked
}) {
  const {
    stackedValues,
    stackedMin,
    stackedMax
  } = useMemo(() => {
    if (!isStacked || data.length === 0) {
      return {
        stackedMin: 0,
        stackedMax: 0,
        stackedValues: []
      };
    }
    const {
      stackedValues,
      formattedStackedValues
    } = getStackedValuesFromDataSeries(data);
    const {
      min,
      max
    } = getStackedMinMax({
      stackedValues,
      data,
      integersOnly: false
    });
    return {
      stackedMin: min,
      stackedMax: max,
      stackedValues: formattedStackedValues
    };
  }, [isStacked, data]);
  return {
    stackedValues,
    stackedMin,
    stackedMax
  };
}

export { useHorizontalStackedValues };
